import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Edit3, Trash2, Plus, Loader2, Image as ImageIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import api from "../../../../api/axios"; // Your custom axios instance

const ShowCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch Categories from Laravel API
  const fetchCategories = async () => {
    try {
      const res = await api.get("/categories");
      if (res.data.success) {
        setCategories(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Handle Delete
  const handleDelete = async (id) => {
    if (!window.confirm("Voulez-vous vraiment supprimer cette catégorie ?")) return;
    
    try {
      const res = await api.delete(`/categories/${id}`);
      if (res.data.success) {
        setCategories(categories.filter(cat => cat.id !== id));
      }
    } catch (err) {
      console.error("Delete error:", err);
      alert("Erreur lors de la suppression.");
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-6xl mx-auto px-4"
    >
      {/* Header Section */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
        <div>
          <h2 className="text-2xl font-black uppercase tracking-tight text-gray-900">Gestion des Catégories</h2>
          <p className="text-sm font-bold text-[#8A8A89] mt-1">ELECTRO TITAN Structure</p>
        </div>
        
        <Link 
          to="/admin/dashboard/add-category"
          className="flex items-center justify-center gap-2 bg-[#ffaa00] text-white px-6 py-3 rounded-2xl text-xs font-black uppercase tracking-[0.15em] shadow-lg shadow-orange-100 hover:bg-black transition-all"
        >
          <Plus size={18} /> Nouvelle Catégorie
        </Link>
      </div>

      {/* Content Table */}
      <div className="bg-white rounded-[2.5rem] shadow-xl shadow-gray-200/30 border border-gray-100 overflow-hidden">
        {loading ? (
          <div className="flex flex-col items-center justify-center py-20 gap-4">
            <Loader2 className="animate-spin text-[#ffaa00]" size={40} />
            <p className="text-xs font-black uppercase text-gray-400 tracking-widest">Chargement...</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-gray-50/50 border-b border-gray-100">
                  <th className="px-8 py-6 text-[10px] font-black uppercase tracking-widest text-[#8A8A89]">Aperçu</th>
                  <th className="px-8 py-6 text-[10px] font-black uppercase tracking-widest text-[#8A8A89]">Détails Catégorie</th>
                  <th className="px-8 py-6 text-[10px] font-black uppercase tracking-widest text-[#8A8A89] text-right">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                <AnimatePresence>
                  {categories.map((cat) => (
                    <motion.tr 
                      layout
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0, x: -20 }}
                      key={cat.id} 
                      className="hover:bg-gray-50/50 transition-colors group"
                    >
                      <td className="px-8 py-5">
                        <div className="w-[10rem] h-[auto] rounded-2xl overflow-hidden bg-gray-50 border border-gray-100 shadow-sm relative">
                          {cat.image ? (
                            <img 
                              src={`${process.env.REACT_APP_BACKEND_URL}${cat.image}`}
                              alt={cat.name} 
                              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" 
                            />
                          ) : (
                            <div className="w-full h-full flex items-center justify-center text-gray-300">
                              <ImageIcon size={20} />
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="px-8 py-5">
                        <div className="flex flex-col">
                          <span className="font-black text-base text-gray-900 leading-tight">{cat.name}</span>
                          <span className="text-[10px] font-bold text-[#ffaa00] tracking-tighter mt-1">
                            URL: /categorie/{cat.slug}
                          </span>
                        </div>
                      </td>
                      <td className="px-8 py-5 text-right">
                        <div className="flex justify-end gap-3">

                          <Link to={"../edit-category/"+cat.id}>
                          <button className="p-3 bg-gray-50 text-[#8A8A89] hover:text-[#ffaa00] hover:bg-orange-50 rounded-xl transition-all">
                            <Edit3 size={18} />
                          </button>
                          </Link>

                          <button 
                            onClick={() => handleDelete(cat.id)}
                            className="p-3 bg-gray-50 text-[#8A8A89] hover:text-red-500 hover:bg-red-50 rounded-xl transition-all"
                          >
                            <Trash2 size={18} />
                          </button>
                        </div>
                      </td>
                    </motion.tr>
                  ))}
                </AnimatePresence>
              </tbody>
            </table>
            
            {categories.length === 0 && (
              <div className="text-center py-20">
                <p className="text-sm font-bold text-gray-400">Aucune catégorie trouvée.</p>
              </div>
            )}
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default ShowCategories;